import styled from 'styled-components';

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    row-gap: 0.25rem;
    height: 100%;
    justify-content: space-between;
`;
